<template>
  <form class="lesson-search" @submit.prevent="submit">
    <button type="button" class="btn px-0" v-if="!showing" @click="open">
      <i class="icon-search lead" />
    </button>

    <div v-if="showing" class="d-flex justify-content-end align-items-center">
      <input
        v-model="text"
        type="text"
        class="form-control"
        placeholder="Pesquisar"
        ref="search"
      />
      <button type="submit" class="btn d-lg-none m-0 p-0" @click="submit">
        <i class="icon-search lead" />
      </button>
      <button type="button" class="btn m-0 p-0" @click="close">
        <i class="icon-close lead" />
      </button>
    </div>
  </form>
</template>

<script>
let debounceTime;
export default {
  data() {
    return {
      text: "",
      showing: false
    };
  },
  watch: {
    text(value) {
      if (value !== "") {
        clearTimeout(debounceTime);
        debounceTime = setTimeout(() => {
          this.submit();
        }, 1000);
      }
    }
  },
  methods: {
    open() {
      this.showing = true;
      requestAnimationFrame(() => {
        this.$refs.search.focus();
      });
      if (window.innerWidth < 768) {
        this.$emit("open");
      }
    },
    close() {
      this.showing = false;
      this.text = "";
      if (window.innerWidth < 768) {
        this.$emit("close");
      }
    },
    submit() {
      this.showing = false;
      if (window.innerWidth < 768) {
        this.$emit("close");
      }
      this.$router.push({
        name: "search",
        query: { search: this.text }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-search {
  button {
    max-width: 48px;
  }

  h5 {
    line-height: 38px;
  }

  .form-control {
    background-color: transparent;
    display: flex;
    height: 28px;
    padding: 6px 7px 7px 10px;
    align-items: center;
    border-radius: 4px;
    border: 1px solid var(--verso-light-grey-1, #a6a7b9);
    font-size: 14px;
    color: #fff;
    width: fit-content;
    min-width: 161px;
    max-width: 240px;

    &::placeholder {
      color: var(--l-elevation-16);
    }

    @media screen and (max-width: 768px) {
      min-width: 80px;
      max-width: 150px;
    }
  }

  .close-search {
    min-height: 28px;
    min-width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
